/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-26 13:48:39 */

const Keys = {
  offerLeft: 'offerLeft',
  offerLeft_other: 'offerLeft_other',
  priceLabelWithNight: 'priceLabelWithNight',
  priceLabelWithNight_other: 'priceLabelWithNight_other',
  mapButtonLabel: 'mapButtonLabel',
  selectButtonLabel: 'selectButtonLabel',
  close: 'close',
  perNight: 'perNight',
  total: 'total'
}; export default Keys;